<template>
  <canvas :id="getId()" class="mt-4" width="890" height="400"></canvas>
</template>

<script>
import { Chart, registerables } from 'chart.js';
import { onMounted } from 'vue';

Chart.register(...registerables);

export default {
  components: {},
  props: {
    categories: { type: Object, default: () => {} },
    stats: { type: Object, default: () => {} },
    name: { type: String, default: 'default' },
    attributeName: { type: String, default: () => null },
    options: { type: Object, default: () => ({ showTotal: false }) },
  },
  emits: [],
  setup(props) {
    const getId = () => {
      return props.name + '-line-chart';
    };

    const getChartData = () => {
      let chartData = [];
      for (let timeRange in props.stats) {
        let statsData = props.stats[timeRange];
        if (props.categories[-1]) {
          let dataset = {
            label: props.categories[-1].name,
            data: getCategoryData(-1),
            borderColor: props.categories[-1].color,
            fill: false,
            tension: 0.5,
          };
          chartData.push(dataset);
        }
        for (let key in statsData) {
          if (key > 0 || ((key === 0 || key === '0') && props.options.showTotal)) {
            let dataset = {
              label: props.categories[key].name,
              data: getCategoryData(key),
              borderColor: props.categories[key].color,
              fill: false,
              tension: 0.5,
            };
            chartData.push(dataset);
          }
        }
        break;
      }

      return chartData;
    };

    const getCategoryData = (key) => {
      let dataset = [];
      for (let timeRange in props.stats) {
        if (props.attributeName) {
          dataset.push(props.stats[timeRange][key][props.attributeName] ?? 0);
        } else {
          dataset.push(props.stats[timeRange][key] ?? 0);
        }
      }

      return dataset;
    };

    const getRowHeaders = () => {
      return Object.keys(props.stats).sort();
    };

    const config = {
      type: 'line',
      data: {
        labels: getRowHeaders(),
        datasets: getChartData(),
      },
      options: {
        elements: {
          point: {
            radius: 0,
          },
        },
        scales: {
          y: {
            ticks: {
              reverse: false,
            },
            type: 'linear',
          },
        },
      },
    };

    onMounted(() => {
      const ctx = document.getElementById(getId()).getContext('2d');
      new Chart(ctx, config);
    });

    return {
      getId,
    };
  },
};
</script>
